import { useEffect, useState, type FormEvent } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import { Card, Page, State } from '../components';
interface Tenant {
  id: string;
  name: string;
  createdAt: string;
}
export function SettingsPage() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: ['tenant'], queryFn: () => api<Tenant>('/api/v1/tenant') });
  const [name, setName] = useState('');
  useEffect(() => {
    if (query.data) setName(query.data.name);
  }, [query.data]);
  const save = useMutation({
    mutationFn: () => api('/api/v1/tenant', { method: 'PATCH', body: JSON.stringify({ name }) }),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ['tenant'] });
      void client.invalidateQueries({ queryKey: ['me'] });
    },
  });
  const submit = (e: FormEvent) => {
    e.preventDefault();
    save.mutate();
  };
  return (
    <Page
      title="Tenant settings"
      description="Neutral workspace settings; prospective-client branding is not hardcoded."
    >
      <State loading={query.isLoading} error={query.error}>
        <Card>
          <form className="settings-form" onSubmit={submit}>
            <label>
              Workspace name
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                maxLength={120}
              />
            </label>
            {save.error && <p className="form-error">{save.error.message}</p>}
            <button className="primary" disabled={save.isPending}>
              Save settings
            </button>
          </form>
        </Card>
      </State>
    </Page>
  );
}
